namespace Portico.Models.Enterprise {
    import pmg = Portico.Models.Gateway;

    export interface INdc {
        id: number;
		name: string;
        drugNumber: string;
		strengthDescription: string;
		programNdcXrefId: number;
		programPromotionXrefId: number;
    }

	export class Ndc implements INdc {
		id: number;
		name: string;
		drugNumber: string;
		strengthDescription: string;
		programNdcXrefId: number;
		programPromotionXrefId: number;

		constructor(obj?: INdc | any) {
            this.id = null;
			this.name = '';
			this.drugNumber = '';
			this.strengthDescription = '';
			this.programNdcXrefId = null;
			this.programPromotionXrefId = null;

            if (obj) {
				this.id = obj.id || obj.Id || null;
				this.name = obj.name || obj.Name || '';
				this.drugNumber = obj.drugNumber || obj.DrugNumber || '';
				this.strengthDescription = obj.strengthDescription || obj.StrengthDescription || '';
				this.programNdcXrefId = obj.programNdcXrefId || obj.ProgramNdcXrefId || null;
				this.programPromotionXrefId = obj.programPromotionXrefId || obj.ProgramPromotionXrefId || null;
            }
        }
    }
}
